var _excluded = ["size", "color", "onClick", "cursor", "display", "data-test-name", "aria-label"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import * as React from "react"; // DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details

import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import { colorNessieResponsivePropType, oneOfNessieResponsivePropType } from "../../propTypes";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
var IdeasIcon = function IdeasIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "m" : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "shale" : _ref$color,
    onClick = _ref.onClick,
    cursor = _ref.cursor,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? "inline-block" : _ref$display,
    dataTestName = _ref["data-test-name"],
    ariaLabel = _ref["aria-label"],
    props = _objectWithoutProperties(_ref, _excluded);
  var sizeInPixels = SIZES[size];
  var ButtonOrSpan = onClick ? UnstyledButton : "span";
  return _jsx(ButtonOrSpan, {
    "aria-label": ariaLabel,
    "data-test-name": dataTestName,
    onClick: onClick,
    sx: {
      fontSize: sizeInPixels,
      display: display,
      lineHeight: 0,
      color: color,
      cursor: cursor,
      position: "relative"
    },
    children: _jsxs("svg", _objectSpread(_objectSpread({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {}, {
      children: [_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.206 21.406c1.698-.31 3.453-.82 4.26-2.94 0-.028-.027-.085-.083-.085-.724.424-1.671.48-1.977.48-.084 0-.112-.028-.112-.113-.027-.31-.112-1.272.223-2.035.028-.028-.027-.085-.084-.085-1.976 1.074-2.283 2.882-2.394 4.636.027.086.11.142.167.142zm-2.173-8.48c-.084.114 0 .283.167.198 2.2-.734 4.371-.396 5.124-.227.166.029.223.198.194.311l-.5 1.924c-.028.114.027.283.167.31a4.78 4.78 0 011.392.82c.53.51.863 1.018.975 1.328.084.114.194.17.305.114l1.81-.735c.168-.027.279 0 .363.17.224.706.863 2.912.363 5.2-.028.114.111.227.223.114 1.059-1.216 3.148-3.93 2.98-7.914 0-.085.027-.113.083-.17C21.11 9.566 21.917 3.998 22 1c-2.896.424-8.299 1.893-12.364 7.914-.084.028-.112.086-.196.086-3.899.31-6.32 2.74-7.407 3.927zm14.23-5.425c.807.734.89 2.034.166 2.882a2.023 2.023 0 01-2.84.17c-.808-.735-.89-2.035-.167-2.883.752-.848 2.034-.932 2.84-.17z"
      }), _jsx("mask", {
        maskUnits: "userSpaceOnUse",
        x: 2,
        y: 1,
        width: 20,
        height: 22,
        children: _jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.206 21.406c1.698-.31 3.453-.82 4.26-2.94 0-.028-.027-.085-.083-.085-.724.424-1.671.48-1.977.48-.084 0-.112-.028-.112-.113-.027-.31-.112-1.272.223-2.035.028-.028-.027-.085-.084-.085-1.976 1.074-2.283 2.882-2.394 4.636.027.086.11.142.167.142zm-2.173-8.48c-.084.114 0 .283.167.198 2.2-.734 4.371-.396 5.124-.227.166.029.223.198.194.311l-.5 1.924c-.028.114.027.283.167.31a4.78 4.78 0 011.392.82c.53.51.863 1.018.975 1.328.084.114.194.17.305.114l1.81-.735c.168-.027.279 0 .363.17.224.706.863 2.912.363 5.2-.028.114.111.227.223.114 1.059-1.216 3.148-3.93 2.98-7.914 0-.085.027-.113.083-.17C21.11 9.566 21.917 3.998 22 1c-2.896.424-8.299 1.893-12.364 7.914-.084.028-.112.086-.196.086-3.899.31-6.32 2.74-7.407 3.927zm14.23-5.425c.807.734.89 2.034.166 2.882a2.023 2.023 0 01-2.84.17c-.808-.735-.89-2.035-.167-2.883.752-.848 2.034-.932 2.84-.17z"
        })
      })]
    }))
  });
};
var SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px"
};
IdeasIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"])
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  IdeasIcon = nessiePropCheckerWrapper(IdeasIcon);
}
export default IdeasIcon;